import { createSlice, createAsyncThunk, Dispatch } from "@reduxjs/toolkit";
import EventServices from "../../../../services/event";
import {
  IEventModel,
  ILuckyWheelSummaryModel,
  IPrizeModel,
} from "../../../../models/eventModel";
import { IRootState } from "../../../../models/interface";
const initialState: IEventState = {
  store_code: null,
  customers: [],
  lst_summary_queue: [],
  event_info: null,
  gifts: [],
  first_load_data: true,
  trigger_load_lasted: false
};

export const fetchDataEventInfo = createAsyncThunk(
  "event/fetchDataEventInfo",
  async () => {
    const response = await EventServices.getEventLuckyWheel();
    return response;
  }
);


export const fetchDataSummary = createAsyncThunk<
  ILuckyWheelSummaryModel[],
  void,
  { state: IRootState }
  >("event/fetchDataSummary", async (_, { getState }) => {
  const state = getState();
  if (!state) {
    return [];
  }
    const { store_code, event_info } = state.event;
    if (!event_info || !store_code) {
      return [];
    }
    const response = await EventServices.getEventLuckyWheelSummary(
      event_info._id,
      store_code
    );
    return response ? response : [];
  });


export const fetchDataSummaryLasted = createAsyncThunk<
  ILuckyWheelSummaryModel[],
  void,
  { state: IRootState }
>("event/fetchDataSummaryLasted", async (_, { getState }) => {
  const state = getState();
  if (!state) {
    return [];
  }
  const { store_code, event_info, last_id } = state.event;
  if (!event_info || !store_code) {
    return [];
  }
  const response = await EventServices.getEventLuckyWheelSummary(
    event_info._id,
    store_code,
    last_id
  );
  return response ? response : [];
});

export const fetchDataGifts = createAsyncThunk<
  IPrizeModel[],
  void,
  { state: IRootState }
>("event/fetchDataGifts", async (_, { getState }) => {
  const state = getState();

  if (!state) {
    return [];
  }

  const { store_code, event_info } = state.event;

  if (!event_info || !store_code) {
    return [];
  }

  const response = await EventServices.getEventGifts(
    event_info._id,
    store_code
  );

  return response ? response : [];
});

export const eventSlice = createSlice({
  name: "event",
  initialState: initialState,
  reducers: {
    setStoreCode: (state, action) => {
      state.store_code = action.payload;
    },
    setEventInfo: (state, action) => {
      state.event_info = action.payload;
    },
    removeSummaryQueueById: (state, action) => {
      if (!state.lst_summary_queue?.length) {
        return;
      }
      let lst = state.lst_summary_queue;
      const index = lst.findIndex((x) => x._id == action.payload);
      if (index > -1) {
        lst.splice(index, 1);
      }
      state.lst_summary_queue = lst;
    },
    setLastedId: (state, action) => {
      state.last_id = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataEventInfo.pending, (state) => {
        // state.loading = true;
      })
      .addCase(fetchDataEventInfo.fulfilled, (state, action) => {
        state.event_info = action.payload;
      })
      .addCase(fetchDataSummaryLasted.pending, (state) => {
        // state.loading = true;
      })
      .addCase(fetchDataSummaryLasted.fulfilled, (state, action) => {
        let lst = action.payload
        const firstLoad = state.last_id == undefined || state.last_id == null

        if (lst?.length) {
          state.last_id = lst?.[0]?._id;
        }

        if (firstLoad) {
          return;
        }


        const lstQueue = state.lst_summary_queue
        if (lstQueue?.length) {
          lst = lst.filter(x => lstQueue?.findIndex(y => y._id == x._id) == -1)
        }

        if (lst.length) {
          lst = state.lst_summary_queue.concat(
            lst
          );

          state.lst_summary_queue = lst
        }
      })
      .addCase(fetchDataSummary.pending, (state) => {
        // state.loading = true;
      })
      .addCase(fetchDataSummary.fulfilled, (state, action) => {
        const lst = action.payload
        if (!lst?.length) {
          state.customers = fakeMissingData([])
          state.trigger_load_lasted = true
          state.lst_summary_queue = []
          state.last_id = undefined
          if (state.first_load_data) {
            state.first_load_data = false
          }
          return
        }

        if (!state.first_load_data && state?.customers?.every(x => x.is_empty) && lst.length && !state.last_id) {
          state.lst_summary_queue = lst
        }


        if (state?.lst_summary_queue?.length && lst.length) {
          state.lst_summary_queue = state.lst_summary_queue.filter(x => lst.findIndex(y => y._id == x._id) != -1)
        }

        let results = fakeMissingData(lst)
        state.customers = results;
        if (state.first_load_data) {
          state.first_load_data = false
        }
      })
      .addCase(fetchDataGifts.pending, (state) => {
        // state.loading = true;
      })
      .addCase(fetchDataGifts.fulfilled, (state, action) => {
        state.gifts = action.payload;
      });
  },
});

export const { setStoreCode, setEventInfo, removeSummaryQueueById, setLastedId } =
  eventSlice.actions;


const fakeMissingData = (lst: ILuckyWheelSummaryModel[]) => {
  const missingLength = 10 - (lst?.length ? lst.length : 0)
  if (missingLength <= 0) {
    return lst;
  }
  const lstEmpty = new Array(missingLength).fill({
    is_empty: true
  })

  return [...lst, ...lstEmpty];
}

export const actionSetLastedId = (id?: string) => (dispatch: Dispatch) => {
  dispatch(setLastedId(id));
};

export const removeItemSummaryQueue = (id?: string) => (dispatch: Dispatch) => {
  if (!id) {
    return;
  }

  dispatch(removeSummaryQueueById(id));
};

// export const getListEventSummary = () => {
//     EventServices.getEventLuckyWheelSummary()
// }

export const selectEventInfo = (state: IRootState) => state.event.event_info;
export const selectStoreCode = (state: IRootState) => state.event.store_code;
export const selectGifts = (state: IRootState) => state.event.gifts;
export const selectListSummary = (state: IRootState) => state.event.customers;
export const selectLstSummaryQueue = (state: IRootState) =>
  state.event.lst_summary_queue;

export default eventSlice.reducer;

export interface IEventState {
  customers: ILuckyWheelSummaryModel[];
  store_code: string | null;
  lst_summary_queue: ILuckyWheelSummaryModel[];
  event_info: IEventModel | null;
  last_id?: string;
  gifts: IPrizeModel[];
  first_load_data: boolean,
  trigger_load_lasted: boolean
}
